<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-sm-10 col-md-6 col-lg-4 g-0">
      <div class="card my-3">
        <app-user-title title="wachtwoord vergeten" [icon]="faKey">
        </app-user-title>
        @if(!processing()) {
          <div class="card-body card-body-auth">
            @if(alert) {
              <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
            }
            @if(!isLoggedIn() && codeSend) {
              <div class="card card-body mx-auto bg-faded form-password-reset mt-3">
                <legend class="m-b-1 text-xs-center">de code, om je wachtwoord te wijzigen, is gemaild</legend>
                <button role="button" class="btn btn-secondary my-3" [routerLink]="['/user/passwordchange']"
                  [queryParams]="{ emailaddress: form.controls.emailaddress.value }">naar
                  wachtwoord wijzigen</button>
                <ngb-alert class="mb-0" type="warning">Let op: het kan zijn dat de email in de spam-folder is gekomen.
                </ngb-alert>
              </div>
            }
            @if(!codeSend) {
              @if(isLoggedIn()) {
                <div class="card card-body mx-auto bg-faded form-password-reset mt-3">
                  <legend class="m-b-1 text-xs-center">je bent al ingelogd</legend>
                  <button role="button" class="btn btn-outline-secondary" [routerLink]="['/']">ga terug</button>
                </div>
              } @else {
                <form name="form" (ngSubmit)="sendCode()" [formGroup]="form" novalidate>
                  <div class="form-group row">
                    <div class="input-group">
                      <span class="input-group-text" id="basic-addon1">
                        <fa-icon [icon]=faEnvelope></fa-icon>
                      </span>
                      <input class="form-control"
                        type="text" formControlName="emailaddress" placeholder="emailadres" required>
                    </div>
                  </div>
                  <div class="row mt-4 g-0">
                    <button [disabled]="form.invalid" type="submit" class="btn btn-primary">
                      code sturen
                    </button>
                  </div>
                </form>
              }
            }
          </div>
        } @else {
        <h2 class="text-center">
          <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
        </h2>
        }
      </div>
    </div>
  </div>
</div>